var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUndrawSearching(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 216,
    height: 126.001,
    viewBox: "0 0 216 126.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "undraw_searching_re_3ra9_2_",
    "data-name": "undraw_searching_re_3ra9 (2)",
    transform: "translate(0 -107.051)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25194",
    "data-name": "Path 25194",
    d: "M234.179,208.647H156.011A11.929,11.929,0,0,1,144.1,196.731V118.563a11.929,11.929,0,0,1,11.916-11.916h78.168A11.929,11.929,0,0,1,246.1,118.563v78.168a11.929,11.929,0,0,1-11.916,11.916ZM156.011,108.554A10.009,10.009,0,0,0,146,118.563v78.168a10.009,10.009,0,0,0,10.009,10.009h54.755a33.423,33.423,0,0,0,33.423-33.423V118.563a10.009,10.009,0,0,0-10.009-10.009H156.011Z",
    transform: "translate(-88.094 0.404)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25195",
    "data-name": "Path 25195",
    d: "M185.334,132.106a6.658,6.658,0,0,0-6.651,6.651v10.41a6.658,6.658,0,0,0,6.651,6.651h10.41a6.658,6.658,0,0,0,6.651-6.651v-10.41a6.658,6.658,0,0,0-6.651-6.651Z",
    transform: "translate(-108.865 -15.511)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25196",
    "data-name": "Path 25196",
    d: "M185.334,207.106a6.658,6.658,0,0,0-6.651,6.651v10.41a6.658,6.658,0,0,0,6.651,6.651h10.41a6.658,6.658,0,0,0,6.651-6.651v-10.41a6.658,6.658,0,0,0-6.651-6.651Z",
    transform: "translate(-108.865 -61.206)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25197",
    "data-name": "Path 25197",
    d: "M185.334,282.106a6.658,6.658,0,0,0-6.651,6.651v10.41a6.658,6.658,0,0,0,6.651,6.651h10.41a6.658,6.658,0,0,0,6.651-6.651v-10.41a6.658,6.658,0,0,0-6.651-6.651Z",
    transform: "translate(-108.865 -106.901)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25213",
    "data-name": "Path 25213",
    d: "M304.424,23.742a11.871,11.871,0,1,1,11.871-11.871,11.885,11.885,0,0,1-11.871,11.871Zm0-18.994a7.123,7.123,0,1,0,7.123,7.123A7.13,7.13,0,0,0,304.424,4.748Z",
    transform: "translate(-179.24 116.595)",
    fill: "#4c9f41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25214",
    "data-name": "Path 25214",
    d: "M348.6,57.721a2.362,2.362,0,0,1-1.623-.642L335.837,46.638a2.374,2.374,0,1,1,3.246-3.464l11.142,10.442a2.374,2.374,0,0,1-1.623,4.106Z",
    transform: "translate(-205.154 90.683)",
    fill: "#4c9f41"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_16746",
    "data-name": "Group 16746",
    transform: "translate(0 194.193)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25215",
    "data-name": "Path 25215",
    d: "M497.6,447.3a.887.887,0,0,0,.643-1.537l-.061-.242.024-.058a2.381,2.381,0,0,1,4.392.016,21.146,21.146,0,0,1,1.858,5.293,7.045,7.045,0,0,1-.124,2.423,28.243,28.243,0,0,0,2.569-11.73,27.267,27.267,0,0,0-.169-3.041q-.14-1.242-.389-2.466a28.57,28.57,0,0,0-5.666-12.109,7.6,7.6,0,0,1-3.162-3.281,5.8,5.8,0,0,1-.527-1.585,7.157,7.157,0,0,0,.464-2.468c.215-.326.6-.487.833-.805,1.165-1.58,2.771-1.3,3.609.843,1.79.9,1.808,2.4.709,3.844-.7.917-.795,2.158-1.408,3.139.063.081.129.159.192.24a28.755,28.755,0,0,1,3,4.755,11.954,11.954,0,0,1,.714-5.552,20.023,20.023,0,0,1,3.091-4.46,2.453,2.453,0,0,1,4.37,1.2l.007.063q-.251.142-.492.3a1.2,1.2,0,0,0,.485,2.189l.024,0a11.97,11.97,0,0,1-.315,1.789c1.446,5.594-1.676,7.631-6.135,7.722-.1.05-.194.1-.293.149a29.351,29.351,0,0,1,1.58,7.435,27.833,27.833,0,0,1-.02,4.495l.008-.053a7.356,7.356,0,0,1,2.511-4.247c1.932-1.587,4.663-2.172,6.747-3.448a1.38,1.38,0,0,1,2.114,1.343l-.008.056a8.068,8.068,0,0,0-.906.437q-.251.142-.492.3a1.2,1.2,0,0,0,.485,2.189l.025,0,.05.008a11.979,11.979,0,0,1-2.2,3.45c-.9,4.883-4.789,5.346-8.944,3.924h0a29.34,29.34,0,0,1-1.971,5.754h-7.041c-.025-.078-.048-.159-.071-.237a8,8,0,0,0,1.948-.116c-.522-.641-1.045-1.287-1.567-1.928a.433.433,0,0,1-.033-.038c-.265-.328-.533-.654-.8-.982h0a11.716,11.716,0,0,1,.343-2.985h0Z",
    transform: "translate(-303.798 -415.702)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25216",
    "data-name": "Path 25216",
    d: "M0,513.579a.482.482,0,0,0,.465.5h215.07a.5.5,0,0,0,0-1H.465A.482.482,0,0,0,0,513.579Z",
    transform: "translate(0 -475.22)",
    fill: "#ccc"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawSearching);
export default __webpack_public_path__ + "static/media/undraw_searching.0564db629b7c246b9aa0efec3bda01c2.svg";
export { ForwardRef as ReactComponent };